<template>
  <b-modal
    header-close-content=""
    id="from-text-file-modal"
    modal-class="from-text-file-modal"
    body-class="modal-body"
    :title="$t('GenerateFromTextFile')"
    centered
    @hide="onHide"
    @shown="reset"
    hide-footer>
    <intro v-if="currentStep == 'Intro'" @stepChange="stepChange" />
    <existing-catalog
      v-if="currentStep == 'ExistingCatalog'"
      @stepChange="stepChange"
      v-model:selectedExistingCatalogId="selectedExistingCatalogId"
      @setCatalogName="(selectedCatalogName) => (selectedExistingCatalogName = selectedCatalogName)" />
    <catalog-options v-if="currentStep == 'CatalogOptions'" @stepChange="setFileData" :filePassed="file" :fileDataPassed="fileData" :fields="fields" />
    <catalog-naming v-if="currentStep == 'CatalogNaming'" @stepChange="setCatalogName" />
    <catalog-finishing
      v-if="currentStep == 'CatalogFinishing'"
      @stepChange="stepChange"
      @finish="error = null"
      :generatedCatalogData="generatedCatalogData"
      :newCatalogName="newCatalogName"
      :existingCatalogName="selectedExistingCatalogName"
      :errorPassed="error" />
  </b-modal>
</template>

<script>
import { useLicenses } from "@common/composable/useRootStore";
import { mapState } from "vuex";
import activityApi from "@services/activity.ts";
import apps from "@services/applications.ts";
import automationServerApi from "@services/automationServer.ts";
import catalogApi from "@services/catalogs.js";
import catalogFinishing from "./FromTextFile/CatalogFinishing.vue";
import catalogNaming from "./FromTextFile/CatalogNaming.vue";
import catalogOptions from "./FromTextFile/CatalogOptions.vue";
import existingCatalog from "./FromTextFile/ExistingCatalog.vue";
import intro from "./FromTextFile/Intro.vue";

export default {
  setup: function () {
    const { checkForLicensed } = useLicenses();
    return { checkForLicensed };
  },
  components: {
    intro,
    existingCatalog,
    catalogOptions,
    catalogNaming,
    catalogFinishing
  },

  data() {
    return {
      currentStep: "Intro",
      stepOrder: ["Intro", "ExistingCatalog", "CatalogOptions", "CatalogNaming", "CatalogFinishing"],
      selectedExistingCatalogId: null,
      selectedExistingCatalogName: null,
      file: null,
      fileData: null,
      fields: null,
      newCatalogName: null,
      finalData: null,
      generatedCatalogData: null,
      fetchedSourceFields: null,
      error: null
    };
  },

  computed: {
    ...mapState("metadata", ["contentLanguages"]),
    ...mapState(["meta", "globalParameters"]),
    primaryLanguage() {
      return this.contentLanguages?.enabled[0];
    },
    language() {
      return this.primaryLanguage?.languageCode;
    }
  },

  methods: {
    async setCatalogName(e) {
      this.stepChange(e);
      this.newCatalogName = e.catalogName;
      if (this.currentStep === "CatalogFinishing") this.finalData = await this.generateCatalog();
    },

    setFileData(e) {
      this.fileData = e.fileData;
      this.file = e.file;
      this.fields = e.fields;
      this.stepChange(e);
    },

    stepChange(event) {
      this.currentStep = event.nextState;
    },

    onHide() {
      this.currentStep = "Intro";
      this.selectedExistingCatalogId = null;
      this.generatedCatalogData = null;
    },

    reset() {
      this.selectedExistingCatalogId = null;
      this.selectedExistingCatalogName = null;
      this.file = null;
      this.fileData = null;
      this.fields = null;
      this.newCatalogName = null;
      this.finalData = null;
      this.generatedCatalogData = null;
      this.fetchedSourceFields = null;
      this.error = null;
    },

    async generateCatalog() {
      const data = {
        ...this.fileData,
        newCatalogName: this.newCatalogName,
        selectedCatalogId: this.selectedExistingCatalogId
      };
      try {
        this.generatedCatalogData = await catalogApi.generateCatalogFromFile(this.language, data);
        this.createActivity();
        if (this.checkForLicensed("AutomationServer")) {
          this.executeAutomation();
        }
      } catch (exception) {
        if (exception.response.data.error) this.error = exception.response.data.error;
      }
    },
    async createActivity() {
      try {
        if (this.globalParameters.IsActivityFeedEnabled) {
          const activityCriterias = [
            {
              severity: "Information",
              applicationId: apps.Modules.ChannelCreator.Id,
              process: "Create",
              objectType: "Catalog",
              objectValue: this.newCatalogName ? this.newCatalogName : "",
              status: "Successful",
              action: "Completed",
              descriptionKey: "CatalogGeneratedFromCSV",
              descriptionValues: [this.newCatalogName]
            }
          ];
          await activityApi.createActivity(activityCriterias);
        }
      } catch (error) {
        console.error("Activity insertion for catalog creation text file process failed with error : ", error);
      }
    },
    async executeAutomation() {
      try {
        await automationServerApi.executeAutomationsIfRequired(["CatalogCreated"]);
      } catch (error) {
        console.error("Automation execution for the trigger type 'Catalog created' failed with error : ", error);
      }
    }
  }
};
</script>
